import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { truncateString } from "../../commonFunctions/CommonFunctions";

// Define an interface for your component props
interface StatusProps {
    value: string;
    toolTip?: boolean;
    style?: React.CSSProperties;
}

// Function to determine the color based on the status value
const getStatusColor = (value: string): string => {
    switch (value?.toLowerCase()) {
        case 'approved':
        case 'accepted':
        case 'survey accepted':
        case 'active':
        case 'completed':
            return 'green';
        case 'payment received':
        case 'paid':
            return '#8AB800'
        case 'rejected':
        case 'survey rejected':
            return '#D2122E'; //red shade
        case 'absent':
            return '#AA0000'; //red shade
        case 'in active':
        case 'inactive':
        case 'lead created':

            return '#A9A9A9'
        case 'reportsubmitted':
        case 'report submitted':
            return '#CC5500';
        case 'pending':
        case 'site visit':
            return 'orange';
        case 'qutation created':
            return ' #E35335'
        case 'estimate updated':
        case 'estimate created':
            return ' #751400'
        case 'task assigned':
            return '#4caf50'
        case 'new':
            return '#009688'
        case 'qualified':
            return 'green'
        case 'qualified':
            return 'green'
        case 'work order created':
        case 'work order updated':
            return '#000075'
        case 'invoice created':
            return '#004700'
        default:
            return 'black'; // Default color if the status doesn't match any case
    }
};

// Define and export the memoized component in one line
export const WSStatus: React.FC<StatusProps> = React.memo(({ value, toolTip = false, style }) => {
    const statusColor = getStatusColor(value);

    return (
        <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
            {/* Dot prefix with the status color */}
            <span
                style={{
                    backgroundColor: statusColor,
                    borderRadius: '50%',
                    width: 8,
                    height: 8,
                    marginRight: 6,
                    display: 'inline-block',
                }}
            />
            {toolTip ? (
                <Tooltip title={value} placement="top">
                    <Typography style={{ color: statusColor, fontSize: '0.75rem', ...style }}>
                        {truncateString(value, 20)}
                    </Typography>
                </Tooltip>
            ) : (
                <Typography style={{ color: statusColor, fontSize: '0.75rem', ...style }}>
                    {value}
                </Typography>
            )}
        </div>
    );
});
